import React, { useContext } from 'react';
import { Box } from '@mui/material';
import WinManagerContext from '../../providers/winManagerProvider';

function WindowsManager() {
  const { linkComponents, currentURL } = useContext(WinManagerContext);
  return (
    <Box
      className="windows-manager"
      id="body"
      sx={{ height: 1 }}
    >
      {linkComponents.map((el) => {
        const Comp = el.component;
        return (
          <Box
            key={`windowed-component-of-${el.url}`}
            sx={{ display: el.url === currentURL ? 'block' : 'none', height: 1 }}
          >
            <Comp {...el.props} />
          </Box>
        );
      })}
    </Box>
  );
}

export { default as LinkComponent } from './link';

export default WindowsManager;
